import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _descriptor2, _descriptor3;
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { DragOverValidationErrorTooltip } from "abreact/expression/ui/editor/impl/dragDrop/DragOverValidationErrorTooltip";
import { CssUtils } from "abreact/incubator/ui/utils/CssUtils";
import { AbMouseOverListener } from "abreact/utils/AbMouseOverListener";
import { action, computed, makeObservable, observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
export let AbDragDropTarget = (_dec = observable.ref, _dec2 = observable.ref, _dec3 = action.bound, _dec4 = action.bound, _dec5 = action.bound, observer(_class = (_class2 = class AbDragDropTarget extends React.Component {
  constructor(props) {
    super(props);
    _initializerDefineProperty(this, "mouseOverListener", _descriptor, this);
    _initializerDefineProperty(this, "dragOverValidationResult", _descriptor2, this);
    _initializerDefineProperty(this, "isDragOver", _descriptor3, this);
    this.onDrop = this.onDrop.bind(this);
    makeObservable(this);
  }
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AbMouseOverListener, {
      ref: this.ref,
      "data-test-id": this.props.dataTestId,
      className: this.className,
      onDragEnter: this.getDisabledAware(this.props.onDragEnter),
      onDragOver: this.getDisabledAware(this.startDragOver),
      onDragLeave: this.getDisabledAware(this.endDragOver),
      onDragExit: this.getDisabledAware(this.endDragOver),
      onDrop: this.getDisabledAware(this.onDrop)
    }, /*#__PURE__*/React.createElement("div", {
      className: "ab-pointer-events-gate",
      style: {
        pointerEvents: this.getDisabledAware(this.pointerEvents)
      }
    }, this.props.children)), this.dragOverValidationErrorTooltip);
  }
  getDisabledAware(value) {
    return this.props.disabled === true ? undefined : value;
  }
  ref(mouseOverListener) {
    this.mouseOverListener = mouseOverListener;
  }
  get className() {
    const classNames = ["ab-drag-drop-target", this.props.className];
    if (this.isDragOver && this.dragOverValidationResult != null) {
      classNames.push(this.dragOverValidationResult.isValid ? "ab-valid-drag-over" : "ab-invalid-drag-over");
    }
    return CssUtils.composeClassNames(...classNames);
  }
  get pointerEvents() {
    return this.mouseOverListener?.isMouseOver ? "inherit" : "none";
  }
  get dragOverValidationErrorTooltip() {
    if (this.dragOverValidationResult != null && !this.dragOverValidationResult.isValid) {
      if (this.dragOverValidationResult.validationErrorTooltipContents != null) {
        return /*#__PURE__*/React.createElement(DragOverValidationErrorTooltip, {
          origin: this.mouseOverListener?.element ?? null
        }, this.dragOverValidationResult.validationErrorTooltipContents);
      }
    }
  }
  startDragOver(e) {
    this.isDragOver = true;
    let dragOverValidationResult;
    if (this.props.dragDropMachine.isDragOverRelevant?.(e) ?? true) {
      dragOverValidationResult = this.props.onDragOver?.(e);
      if (dragOverValidationResult == null || dragOverValidationResult.isValid) {
        dragOverValidationResult = this.props.dragDropMachine.onDragOver(e, this.props.dragOverContext);
        if (dragOverValidationResult.isValid) {
          e.preventDefault();
        }
      }
    }
    this.dragOverValidationResult = dragOverValidationResult;
  }
  endDragOver() {
    this.isDragOver = false;
    this.dragOverValidationResult = undefined;
  }
  onDrop(e) {
    this.endDragOver();
    if (this.props.dragDropMachine.isDropRelevant?.(e) ?? true) {
      this.props.onDrop?.(e);
      this.props.dragDropMachine.onDrop(e, this.props.dropContext);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "mouseOverListener", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "dragOverValidationResult", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "isDragOver", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "ref", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "ref"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "className", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "className"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "pointerEvents", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "pointerEvents"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "dragOverValidationErrorTooltip", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "dragOverValidationErrorTooltip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "startDragOver", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "startDragOver"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "endDragOver", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "endDragOver"), _class2.prototype), _class2)) || _class);
//# sourceMappingURL=AbDragDropTarget.js.map
